import React, { useState, useEffect, useRef } from 'react';
import { Form, Button } from 'react-bootstrap';

const SpecialHoldReasonsInput = ({
  splInsOptions = [],
  formData,
  setFormData,
  id
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Initialize input value from formData
  useEffect(() => {
    const currentItem = formData.find(item => item.rx_hold_id === id);
    const match = splInsOptions.find(opt => String(opt.value) === String(currentItem?.select_rxreason));
    setInputValue(match ? match.key : currentItem?.select_rxreason || '');
  }, [formData, id, splInsOptions]);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowOptions(true);
  };

  const handleSelect = (value, key) => {
    const updatedData = formData.map(item => {
      if (Number(item.rx_hold_id) === Number(id)) {
        return {
          ...item,
          select_rxreason: value
        };
      }
      return item;
    });
    setFormData(updatedData);
    setInputValue(key);
    setShowOptions(false);
  };

  const handleBlur = (e) => {
    if (!dropdownRef.current || !dropdownRef.current.contains(e.relatedTarget)) {
      setShowOptions(false);
      const match = splInsOptions.find(opt => opt.key === inputValue);
      if (!match && inputValue) {
        const updatedData = formData.map(item => {
          if (Number(item.rx_hold_id) === Number(id)) {
            return {
              ...item,
              select_rxreason: inputValue
            };
          }
          return item;
        });
        setFormData(updatedData);
      }
    }
  };

  return (
    <Form.Group ref={dropdownRef}>
      <div className="d-flex">
        <Form.Control
          ref={inputRef}
          type="text"
          placeholder="Type or select Reason"
          value={inputValue}
          onChange={handleChange}
          onFocus={() => setShowOptions(true)}
          onBlur={handleBlur}
        />
      </div>

      {showOptions && (
        <div
          className="dropdown-menu show w-100 mt-1"
          style={{
            maxHeight: '150px',
            overflowY: 'auto',
            overflowX: 'hidden',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            position: 'absolute',
            zIndex: 9999,
            top: '100%',
            left: 0
          }}
        >
          {splInsOptions.length > 0 ? (
            splInsOptions
              .filter(option => 
                option.key.toLowerCase().includes(inputValue.toLowerCase())
              )
              .map((option, index) => (
                <button
                  key={index}
                  type="button"
                  className="dropdown-item"
                  style={{ cursor: 'pointer', textAlign: 'left' }}
                  onMouseDown={(e) => e.preventDefault()} // Prevent blur on mousedown
                  onClick={() => handleSelect(option.value, option.key)}
                >
                  {option.key}
                </button>
              ))
          ) : (
            <div className="dropdown-item text-muted">No suggestions</div>
          )}
        </div>
      )}
    </Form.Group>
  );
};

export default SpecialHoldReasonsInput;